// Importa tutte le icone che potresti usare
import {
    WheatOff,
    Beer,
    Pizza,
    Wine,
    GlassWater,
    Martini,
    Salad,
    UtensilsCrossed,
    CircleHelp,
    Crown,
    Beef,
    Drumstick,
    Coffee,
    CakeSlice,
    Torus,
    Hamburger,
    ChefHat,
    Croissant,
    Badge,
} from "lucide-react";

/**
 * Restituisce un'icona Lucide in base all'URL.
 * @param {string} url - URL dell'icona (es: https://cercamenu.com/images/icons/glutenfree.svg)
 * @returns {JSX.Element} Icona Lucide corrispondente
 */
export function getIconCategory(url) {
    if (!url || typeof url !== "string") return <CircleHelp />;

    try {
        const name = url.split("/").pop().replace(".svg", "").toLowerCase();
        switch (name) {
            case "corona":
                return <Crown />;
            case "glutenfree":
                return <WheatOff />;
            case "birre":
                return <Beer />;
            case "pizze":
                return <Pizza />;
            case "vini":
                return <Wine />;
            case "bevande":
                return <GlassWater />;
            case "distillati":
                return <Martini />;
            case "dolci":
                return <CakeSlice />;
            case "insalate":
                return <Salad />;
            case "fritti":
                return <Drumstick />;
            case "caffetteria":
                return <Coffee />;
            case "appetizer":
                return <UtensilsCrossed />;
            case "hot-dog":
                return <Beef />;
            case "hamburger":
                return <Hamburger />;
            case "panzerotti":
                return <Croissant />;
            case "pinse":
                return <Torus />;
            case "piatti-unici":
                return <ChefHat />;
            case "puccia":
                return <Badge />;
            // Aggiungi altri casi se necessario
            default:
                return <CircleHelp />; // icona fallback
        }
    } catch (err) {
        return <CircleHelp />;
    }
}